import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { select } from 'd3-selection';

import { CssMediaService } from '../../lib/media.service';
import { NgClass, NgIf } from '@angular/common';

export enum StateButtonType {
    state1 = 0,
    state2 = 1,
}

@Component({
    selector: 'se-statebutton',
    templateUrl: './se-statebutton.component.html',
    styleUrls: ['./se-statebutton.component.less', './se-statebutton.component.mobile.css'],
    standalone: true,
    imports: [NgClass, NgIf],
})
export class SeStateButtonComponent {
    // events

    @Output()
    stateChange = new EventEmitter<StateButtonType>();

    @Output()
    isFirstStateSelectedChange = new EventEmitter<boolean>();

    // Data Members

    @Input()
    source: string;

    @Input()
    title: string;
    @Input()
    state1Title: string;
    @Input()
    state2Title: string;

    @Input()
    state = StateButtonType.state1;

    @Input()
    isFirstStateSelected = true;

    @Input()
    bindToState = false;

    isPressed = false;

    // Constructor

    constructor(
        private elementRef: ElementRef,
        public cssMediaService: CssMediaService,
    ) {}

    // public functions

    ngOnInit() {
        select(this.elementRef.nativeElement)
            .on('mousedown', () => {
                this.isPressed = true;
            })
            .on('mouseup', () => {
                this.isPressed = false;
                this.onClick();
            });
    }

    // private functions

    private onClick() {
        if (this.bindToState) {
            this.state = this.state == StateButtonType.state1 ? StateButtonType.state2 : StateButtonType.state1;
            this.stateChange.emit(this.state);
        } else {
            this.isFirstStateSelected = !this.isFirstStateSelected;
            this.isFirstStateSelectedChange.emit(this.isFirstStateSelected);
        }
    }
}
